const BASE_URL = process.env.REACT_APP_API_URL || '';

const req = (path, options = {}) =>
  fetch(`${BASE_URL}${path}`, { credentials: 'include', ...options });

export const getPhotos = () =>
  req('/api/photos').then(r => r.json());

export const verifyAuth = () =>
  req('/api/auth/verify').then(r => (r.ok ? r.json() : Promise.reject()));

export const login = (email, password) =>
  req('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  }).then(r => r.json());

export const logout = () =>
  req('/api/auth/logout', { method: 'POST' }).then(r => r.json());

export const uploadPhoto = file => {
  const form = new FormData();
  form.append('file', file);
  return req('/api/photos/upload', { method: 'POST', body: form }).then(r => {
    if (!r.ok) return r.json().then(e => Promise.reject(e));
    return r.json();
  });
};

export const reorderPhotos = ids =>
  req('/api/photos/reorder', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids }),
  }).then(r => r.json());

export const deletePhoto = id =>
  req(`/api/photos/${id}`, { method: 'DELETE' });

// Resume (credits, training, skills, dialects)
export const getResume = () =>
  req('/api/resume').then(r => r.json());

export const createResumeEntry = data =>
  req('/api/resume', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then(r => {
    if (!r.ok) return r.json().then(e => Promise.reject(e));
    return r.json();
  });

export const updateResumeEntry = (id, data) =>
  req(`/api/resume/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then(r => {
    if (!r.ok) return r.json().then(e => Promise.reject(e));
    return r.json();
  });

export const deleteResumeEntry = id =>
  req(`/api/resume/${id}`, { method: 'DELETE' });

export const reorderResumeEntries = ids =>
  req('/api/resume/reorder', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids }),
  }).then(r => r.json());

// Videos
export const getVideos = () =>
  req('/api/videos').then(r => r.json());

export const uploadVideoFile = (file, meta) => {
  const form = new FormData();
  form.append('file', file);
  form.append('title',     meta.title     || '');
  form.append('credit',    meta.credit    || '');
  form.append('director',  meta.director  || '');
  form.append('studio',    meta.studio    || '');
  form.append('thumbTime', meta.thumbTime || '2');
  return req('/api/videos/upload', { method: 'POST', body: form }).then(r => {
    if (!r.ok) return r.json().then(e => Promise.reject(e));
    return r.json();
  });
};

export const updateVideo = (id, data) =>
  req(`/api/videos/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then(r => {
    if (!r.ok) return r.json().then(e => Promise.reject(e));
    return r.json();
  });

export const deleteVideo = id =>
  req(`/api/videos/${id}`, { method: 'DELETE' });

export const reorderVideos = ids =>
  req('/api/videos/reorder', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids }),
  }).then(r => r.json());

// Hero / Title Card
export const getHeroProfile = () =>
  req('/api/hero').then(r => r.json());

export const updateHeroProfile = data =>
  req('/api/hero', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }).then(r => {
    if (!r.ok) return r.json().then(e => Promise.reject(e));
    return r.json();
  });
